import {
  AsxCustomerProfileService,
  asxCustomerProfileServiceHttpBindingInterceptor,
} from '@amzn/coral_com-amazon-asxcustomerprofileservice';
import { CoralFetchHandler, CoralInterceptor, InterceptingHandler } from '@amzn/ihm-js-coral-client';

import { CSRFInterceptor } from 'src/clients/csrf-interceptor';
import { HeaderInterceptor } from 'src/clients/header-interceptor';

export const ACPS_API_PATH = '/';

/**
 * Instantiate a client leveraging the generated Coral Client Http Interceptor bound to the
 * ACPS Model.
 */
export const createAcpsClient = (): AsxCustomerProfileService => {
  const coralClientConfig = {
    httpEndpoint: {
      url: `${ACPS_API_PATH}`,
    },
  };

  const interceptors: CoralInterceptor[] = [
    asxCustomerProfileServiceHttpBindingInterceptor,
    CSRFInterceptor,
    HeaderInterceptor,
  ];

  return new AsxCustomerProfileService(
    coralClientConfig,
    new InterceptingHandler(new CoralFetchHandler(), interceptors)
  );
};

export const acpsClientSingleton = createAcpsClient();
